




























import { ScriptButtonContent } from '@/api/interfaces/content/form/base/scriptButtonContent';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import { ButtonCharacter } from '@/enums/buttonCharacter';
import { ButtonTheme } from '@/enums/buttonTheme';
import { getFormElementMixin } from '@/mixins/formElementMixin';
import { NoValueField } from '@/types/forms/fields/noValueField';
import { PropType } from 'vue';
import FormRow from '../formRow/FormRow.vue';
import InfoIconWrapper from '../infoIconWrapper/InfoIconWrapper.vue';

export default getFormElementMixin<
    NoValueField,
    Record<string, string>
>().extend({
    name: 'FormScriptButton',
    components: {
        FormRow,
        InfoIconWrapper,
        AppButton,
    },
    props: {
        content: {
            type: Object as PropType<ScriptButtonContent>,
            default: () => {
                return {};
            },
        },
        func: {
            type: Function,
            default: undefined,
        },
        model: {
            type: Object,
            default: () => {
                return {};
            },
        },
        character: {
            type: String as PropType<ButtonCharacter>,
            default: ButtonCharacter.raquo,
        },
        characterIsLeft: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        showSummary: {
            type: Boolean,
            default: false,
        },
        showInfoIcon: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String as PropType<ButtonTheme>,
            default: ButtonTheme.buttonPrimary,
        },
    },
});
